/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FaCheck } from 'react-icons/fa';

import { RegularText } from '../../common/Text';
import StyledTappable from '../../common/StyledTappable';

const OuterContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  max-width: 80%;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0.4rem 0;
`;

const BubbleContainer = styled(StyledTappable)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 1rem 1.2rem;
  background: #f7f7f7;
  border-radius: 1.4rem;
`;

const Image = styled.div`
  background-size: cover;
  width: 19rem;
  height: 19rem;
  border-radius: 1.2rem;
  background-image: ${(props) => `url(${props.url})`};
  background-repeat: no-repeat;
`;

const TimestampContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  margin-right: 1.6rem;
`;

const TickIcon = styled(FaCheck)`
  color: #fff;
  opacity: 0.5;
  font-size: 1rem;
  margin-right: 0.4rem;
`;

const TimestampText = styled(RegularText)`
  color: #fff;
  opacity: 0.5;
  font-size: 0.4rem;
`;

const DoctorImageMessage = ({ filePreviewUrl, url, timestamp }) => (
  <OuterContainer>
    <BubbleContainer
      onTap={() => {
        // document.querySelector('#image-anchor').click();
        window.open(url);
      }}
    >
      <Image url={url} />
      {timestamp && (
        <TimestampContainer>
          <TickIcon />
          <TimestampText>
            {new Date(timestamp).toLocaleTimeString('nu', {
              hour: 'numeric',
              minute: '2-digit',
            })}
          </TimestampText>
        </TimestampContainer>
      )}
    </BubbleContainer>
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      id="image-anchor"
      style={{ display: 'none' }}
    />
  </OuterContainer>
);

DoctorImageMessage.propTypes = {
  filePreviewUrl: PropTypes.string,
  url: PropTypes.string,
  timestamp: PropTypes.number,
};

export default DoctorImageMessage;
